module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('v-app', [_c('v-content', [_c('v-container', [_c('v-card', [(_vm.message) ? _c('v-alert', {
    attrs: {
      "value": "message",
      "type": "success",
      "outline": ""
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.message) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('v-alert', {
    attrs: {
      "value": "error",
      "type": "warning",
      "outline": ""
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.error) + " ")])]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "pa-4": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.originatorNames,
      "label": "Originator",
      "solo": "",
      "rules": _vm.originatorRules,
      "required": ""
    },
    on: {
      "change": _vm.getOriginatorFiles
    },
    model: {
      value: (_vm.originator),
      callback: function($$v) {
        _vm.originator = $$v
      },
      expression: "originator"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fileNames,
      "label": "Request File Name",
      "solo": "",
      "rules": _vm.fileNameRules,
      "required": ""
    },
    model: {
      value: (_vm.fileName),
      callback: function($$v) {
        _vm.fileName = $$v
      },
      expression: "fileName"
    }
  }), _vm._v(" "), _c('label', [_vm._v("File\n               "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "id": "file",
      "required": ""
    },
    on: {
      "change": function($event) {
        return _vm.handleFileUpload()
      }
    }
  })]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.uploadFile
    }
  }, [_vm._v("Upload")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a680ad1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/file/uploadprocessingresult.vue
// module id = 1049
// module chunks = 2